export default __webpack_public_path__ + "static/media/x33mall-banner-ms.3988a454.webp";